import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scheduleFields", "startAtField", "intervalField", "recipientUserIdsField", "thresholdField"]

  connect() {
    this.toggleScheduleFields()
    this.toggleThresholdField()
  }

  toggleScheduleFields() {
    const enabledCheckbox = this.element.querySelector('input[type=checkbox][name*="[enabled]"]')
    const isEnabled = enabledCheckbox && enabledCheckbox.checked

    if (isEnabled) {
      this.showScheduleFields()
    } else {
      this.hideScheduleFields()
    }
  }

  toggleThresholdField() {
    const checkbox = this.element.querySelector('input[type=checkbox][id="notify_on_empty_results"]')
    if (!checkbox || !this.hasThresholdFieldTarget) return

    const thresholdWrapper = this.thresholdFieldTarget.closest(".threshold-field")
    if (!thresholdWrapper) return

    if (checkbox.checked) {
      thresholdWrapper.style.display = "none"
      this.thresholdFieldTarget.value = 0
    } else {
      thresholdWrapper.style.display = ""
      if (parseInt(this.thresholdFieldTarget.value) === 0) {
        this.thresholdFieldTarget.value = 1
      }
    }
  }

  showScheduleFields() {
    this.scheduleFieldsTarget.style.display = "block"
    this.startAtFieldTarget.disabled = false
    this.intervalFieldTarget.disabled = false
    if (this.hasRecipientUserIdsFieldTarget) this.recipientUserIdsFieldTarget.disabled = false
  }

  hideScheduleFields() {
    this.scheduleFieldsTarget.style.display = "none"
    this.startAtFieldTarget.disabled = true
    this.intervalFieldTarget.disabled = true
    if (this.hasRecipientUserIdsFieldTarget) this.recipientUserIdsFieldTarget.disabled = true
  }
}
